module.exports = __webpack_public_path__ + "img/thumbnail_NorthIslandBrownKiwi_m_leucistic.fd215d15.png";